import { EvalItem, ExtractResult, RfpFile, RfpFileKind, RfpPageText, ScoreTableFile } from '../types/rfp';
import { apiClient } from './api';

/**
 * 제안요청서 — `projects/:id/rfp/*`. 실패는 그대로 던진다 — 화면이 이유를 보여 준다.
 */
export const rfpApi = {
  list(projectId: number): Promise<RfpFile[]> {
    return apiClient.get(`/projects/${projectId}/rfp`);
  },

  /** 파일을 직접 올린다 — 공고 없이 만든 프로젝트, 또는 첨부에 없던 제안요청서. 올리면 글자까지 뽑는다 */
  upload(projectId: number, file: File): Promise<RfpFile[]> {
    const form = new FormData();
    form.append('file', file);
    return apiClient.postForm(`/projects/${projectId}/rfp/upload`, form);
  },

  /** 스냅샷 첨부를 행으로 만들고 받아서 텍스트까지. 이미 받은 것은 그대로 */
  sync(projectId: number): Promise<RfpFile[]> {
    return apiClient.post(`/projects/${projectId}/rfp/sync`);
  },

  retry(projectId: number, fileId: number): Promise<RfpFile> {
    return apiClient.post(`/projects/${projectId}/rfp/${fileId}/retry`);
  },

  setKind(projectId: number, fileId: number, fileKind: RfpFileKind): Promise<RfpFile> {
    return apiClient.patch(`/projects/${projectId}/rfp/${fileId}/kind`, { fileKind });
  },

  pages(projectId: number, fileId: number, from: number, to: number): Promise<RfpPageText[]> {
    return apiClient.get(`/projects/${projectId}/rfp/${fileId}/pages?from=${from}&to=${to}`);
  },

  /** 첨부 한글 문서의 배점표 — AI 없이 표를 그대로 읽는다. 없으면 [] */
  scoreTables(projectId: number): Promise<ScoreTableFile[]> {
    return apiClient.get(`/projects/${projectId}/rfp/score-tables`);
  },

  /** AI 로 배점표 · 사업 기간 · 지정 목차를 뽑는다. 검수된 행은 덮지 않는다 */
  extract(projectId: number): Promise<ExtractResult> {
    return apiClient.post(`/projects/${projectId}/rfp/extract`);
  },

  evalItems(projectId: number): Promise<EvalItem[]> {
    return apiClient.get(`/projects/${projectId}/rfp/eval-items`);
  },

  addEvalItem(projectId: number, body: { category: string; item: string; points?: number; pageNo?: number }): Promise<EvalItem> {
    return apiClient.post(`/projects/${projectId}/rfp/eval-items`, body);
  },

  patchEvalItem(projectId: number, itemId: number, patch: Partial<Pick<EvalItem, 'category' | 'item' | 'points' | 'pageNo' | 'reviewed'>>): Promise<EvalItem> {
    return apiClient.patch(`/projects/${projectId}/rfp/eval-items/${itemId}`, patch);
  },

  removeEvalItem(projectId: number, itemId: number): Promise<{ id: number }> {
    return apiClient.delete(`/projects/${projectId}/rfp/eval-items/${itemId}`);
  },
};
